var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { AlertService } from '../../service/alert.service';
import { BaseService } from '../base/base.service';
var PasswordService = /** @class */ (function (_super) {
    __extends(PasswordService, _super);
    function PasswordService(logger, api, alertService) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.alertService = alertService;
        return _this;
    }
    PasswordService.prototype.password = function (data) {
        var _this = this;
        this.api.setErrorHandler(this.handleError());
        return this.api.put('/v1/gen/password-change-api', JSON.stringify(data))
            .pipe(map(function (res) {
            var user = JSOG.parse(localStorage.getItem('currentUser'));
            user['isTemporaryPass'] = res['is_temporary_pass'];
            user['isOneTimeAuthenticated'] = true;
            localStorage.setItem('currentUser', JSON.stringify(user));
            if (_this.api.getIsStop()) {
                return null;
            }
            return res;
        }), finalize(function () { return _this.api.clearErrorHandler(); }));
    };
    PasswordService.prototype.handleError = function () {
        var self = this;
        return function (error) {
            var errMsg;
            if (error instanceof HttpErrorResponse) {
                if (!self.api.checkBuildNo(error.headers)) {
                    return throwError('different BuildNo.');
                }
                var body = void 0;
                try {
                    body = error.error;
                }
                catch (e) {
                }
                self.alertService.alert(body);
                var err = JSON.stringify(body);
                errMsg = error.status + " - " + (error.statusText || '') + " " + err;
            }
            else {
                errMsg = error.message ? error.message : error.toString();
            }
            return throwError(errMsg);
        };
    };
    PasswordService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    PasswordService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: AlertService }
    ]; };
    return PasswordService;
}(BaseService));
export { PasswordService };
//# sourceMappingURL=password.service.js.map